import { render } from "./deliveryRegPop.vue?vue&type=template&id=0a095343"
import script from "./deliveryRegPop.vue?vue&type=script&lang=js"
export * from "./deliveryRegPop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__